import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";

const initialFValues = {
  id: 0,
  fromCity: "",
  toCity: "",
  rate: "",
  effectiveDate: "",
};

export default function AddLogisticsCost(props) {
  const { addLogisticsCost, recordForEdit } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("fromCity" in fieldValues)
      temp.fromCity = fieldValues.fromCity ? "" : "This field is required.";
    if ("toCity" in fieldValues)
      temp.toCity = fieldValues.toCity ? "" : "This field is required.";
    if ("rate" in fieldValues)
      temp.rate = fieldValues.rate ? "" : "This field is required.";
    if ("effectiveDate" in fieldValues)
      temp.effectiveDate = fieldValues.effectiveDate
        ? ""
        : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var result = {
        ...values,
      };
      addLogisticsCost(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);
  useEffect(() => {
    // Check if all values are filled
    const allValuesFilled = Object.values(values).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    // Check if file is selected
    if (allValuesFilled) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            label="From City*"
            name="fromCity"
            value={values.fromCity || ""}
            onChange={handleInputChange}
            error={errors.fromCity}
          />
          <Controls.Input
            label="To City*"
            name="toCity"
            value={values.toCity || ""}
            onChange={handleInputChange}
            error={errors.toCity}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            label="Rate"
            name="rate"
            value={values.rate || ""}
            onChange={handleInputChange}
            error={errors.rate}
          />
          <Controls.Input
            name="effectiveDate"
            label="Effective Date*"
            type="date"
            value={values.effectiveDate || ""}
            onChange={handleInputChange}
            error={errors.effectiveDate}
          />
          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
